import { render } from "./Briefcase.vue?vue&type=template&id=50079cf6"
import script from "./Briefcase.vue?vue&type=script&lang=js"
export * from "./Briefcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/DownloadCenter/Briefcase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50079cf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50079cf6', __exports__)) {
    api.reload('50079cf6', __exports__)
  }
  
  module.hot.accept("./Briefcase.vue?vue&type=template&id=50079cf6", () => {
    api.rerender('50079cf6', render)
  })

}


export default __exports__